<template>
    <div ref="slider"></div>
</template>

<script>
import 'jquery-ui/ui/widgets/mouse' // slider depends on this module
import 'jquery-ui/ui/widgets/slider'

export default {
    components: {},
    props: {
        min: Number,
        max: Number,
        value: Number,
        disabled: Boolean
    },
    data() {
        return {
            data: {
                obj: null
            },
            state: {
                // ignore: true,
            }
        }
    },
    methods: {
        init() {
            this.data.obj.slider({
                range: 'min',
                disabled: this.disabled,
                min: this.min,
                max: this.max,
                value: this.value,
                slide: (e, ui) => {
                    this.$emit('slide', ui.value)
                },
                stop: (e, ui) => {
                    // if(this.state.ignore){
                    // 	this.state.ignore = false;
                    // 	return;
                    // }
                    // console.log('stop');

                    this.$emit('change', ui.value)
                }
            })
        },
        update() {
            // this.state.ignore = true;
            // console.log('update');

            if (this.min !== undefined) {
                this.data.obj.slider('option', 'min', this.min)
            }
            if (this.max !== undefined) {
                this.data.obj.slider('option', 'max', this.max)
            }
            if (this.value !== undefined) {
                this.data.obj.slider('option', 'value', this.value)
            }
        },
        checkDisabled() {
            if (this.disabled) {
                this.data.obj.slider('option', 'disabled', true)
            } else {
                this.data.obj.slider('option', 'disabled', false)
                this.update()
            }
        }
    },
    beforeDestroy() {
        this.data.obj.slider('destroy')
    },
    mounted() {
        this.data.obj = $(this.$refs.slider)
        this.init()
        this.update()
        // this.state.ignore = false;
    },
    watch: {
        min() {
            this.update()
        },
        max() {
            this.update()
        },
        value() {
            this.update()
        },
        disabled() {
            if (this.data.obj) {
                setTimeout(() => {
                    this.checkDisabled()
                }, 1000)
            }
        }
    }
}
</script>
